export default __webpack_public_path__ + "static/media/twitter_weiß.798f4e3e.png";